import { JobType } from 'common/src/types/enums/JobType.enum';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import { getRequest, postRequest } from 'portal/src/api/requestTypes';

export const getLatestOperation = async (type: JobType) => {
  try {
    return await getRequest(
      `${API_BASE_PATHS.METADATA.OPERATIONS}/${type}/latest`,
    );
  } catch (e: any) {
    if (e?.json?.statusCode === 404) {
      return null;
    }

    throw e;
  }
};
export const createOperation = async (type: JobType) =>
  await postRequest(`${API_BASE_PATHS.METADATA.OPERATIONS}/${type}`);
